<template>
  <div id="app" style="min-height: 100vh;">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      transitionName: ''
    }
  },

  computed: {
    key() {
      return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
    }
  }
  // beforeRouteUpdate(to, from, next) {
  //   // 如果isBack为true时，证明是用户点击了回退，执行slide-right动画
  //   let isBack = this.$router.isBack
  //   if (isBack) {
  //     this.transitionName = 'slide-right'
  //   } else {
  //     this.transitionName = 'slide-left'
  //   }
  //   // 做完回退动画后，要设置成前进动画，否则下次打开页面动画将还是回退
  //   this.$router.isBack = false
  //   next()
  // }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue